'use client'

import { useSelector } from 'react-redux'
import type { IRedux } from '../_store/types'
import { isDynamicLanguageEnabled } from '../_utils/dynamic-language'

export function useShipper() {
  try {
    return useSelector((state: IRedux) => state?.session?.shipper)
  } catch {
    return null
  }
}

export function useShipperResolved() {
  try {
    return useSelector((state: IRedux) => Boolean(state?.session?.shipperResolved))
  } catch {
    return false
  }
}

export function useDynamicLanguage() {
  const shipper = useShipper()
  const resolved = useShipperResolved()
  return {
    useDynamicLanguage: isDynamicLanguageEnabled(shipper),
    isShipperResolved: resolved,
  }
}
